import { UpdateAreaInput } from '@app/models/area.model'
import { BranchResponse } from '@app/models/branch.model'
import { DataByArea, SubSubEventData } from '@app/models/event.model'
import { EventLocationResponse } from '@app/models/location.model'
import { UpdateStationInput } from '@app/models/station.model'

const keys = Object.keys(new BranchResponse())

const areasStatisticsForKindergarten = `areas_statistics {
    totalInside
    authorizedOverTime
    relatedInside
    totalRelated
    employeesInside
    totalEmployees
    areas {
        ${Object.keys(new DataByArea()).join('\n')}

    }
}`

const areasStatisticsForAuthorized = `
	areas_statistics {
    totalInside
    totalAuthorized
    authorizedOverTime
    authorizedInside
    employeesInside
    totalEmployees
    totalVehicles
    vehiclesInside
    totalHME
    HMEInside
    areas {
			${Object.keys(new DataByArea()).join('\n')}
			sub_event {
				${Object.keys(new SubSubEventData()).join('\n')}
			}
    }
	}`

export const requestFields = `
${keys.join('\n')}    
status 
predefined_location_id
entrancesAmount
time_limitations
entrances {
	id
	name
	parent_id
	type
	stations {
			${Object.keys(new UpdateStationInput()).join('\n')}
			icon
	}
	areas {
		${Object.keys(new UpdateAreaInput()).join('\n')}
	}
	parentEntrances {
			id
	}
	subEntrances {
			id
	}
}
location {        
    ${Object.keys(new EventLocationResponse()).join('\n')}
}
areas {        
    ${Object.keys(new UpdateAreaInput()).join('\n')}
}
event_statistics
{
        totalTickets
        totalScanned
        maxTickets
        scannedPercent
        wrongEntrance
        wrongEntranceName
        eventMismatch
        blockedFraud
        running
        faulted
        icon
        totalToday
        totalInside
        totalOvertime
}
entrances_statistics 
{
id
name
controller
totalTickets
totalScanned
peakPoint
recentMeanScanRate
icon
    stations_statistics 
    {
        id
        entrance_id
        ip
        name
        type
        icon
        areas
        type
        keep_open
        totalTickets
        totalScanned
        peakPoint
        recentMeanScanRate
        entranceScanned
        batteryLevel
        version
    }
}
`

export const GET_BRANCH = `
query get_event($id: Float!, $client_id: Float!) {
    get_event(
        id: $id,
        client_id: $client_id
    ) {
        success
        errorText
        errorFile
        data {
            ${requestFields}
        }
    }
}
`

export const SET_BRANCH = `
mutation create_branch($data: createBranchInput!) {
    create_branch(data: $data) {
        success
        errorText
        data {
            client_id
            id
        }
    }
}
`

export const UPDATE_BRANCH = `
mutation update_branch($data: updateBranchInput!) {
    update_branch(data: $data) {
        success
        errorText
        data {
            client_id
            id
            allow_transfer
            pass_upload_job_id
            location {
                lat
                lon
                name
                display_name
            }
        }
    }
}`

export const RequestPreviewFieldsLocationsPage = `
    id
    name
    max_enforce
    max_participants
    password
    station_type
    allow_transfer
    keep_open
    starting_time
    closing_time
    time_limitations
    secured
    location {        
        ${Object.keys(new EventLocationResponse()).join('\n')}
    }
    event_statistics{
        icon
    }
    post_scan_transfer
    report_location
`

export const RequestPreviewFieldsBranchesPage = `
    id
    name
    max_enforce
    max_participants
    password
    station_type
    allow_transfer
    keep_open
    image
    secured
    client_id
		areas {
				${Object.keys(new UpdateAreaInput()).join('\n')}
			}
    entrances {
			id
			name
			parent_id
			type
			stations {
				${Object.keys(new UpdateStationInput()).join('\n')}
				icon
			}
			areas {
				${Object.keys(new UpdateAreaInput()).join('\n')}
			}
			parentEntrances {
				id
			}
			subEntrances {
				id
			}
    }
    location {        
        ${Object.keys(new EventLocationResponse()).join('\n')}
    }
    event_statistics{
			icon
			scannedPercent
			totalScanned
			totalTickets
			totalToday
			totalInside
			totalOvertime
		}
`

export const RequestPreviewFieldsModalInvitationPage = `
id
name
allow_transfer
client_id
category
nursing_type
location {        
    id
    name
    display_name
    description
    address
  }
  ${areasStatisticsForKindergarten}
event_statistics{
    icon
}
entrances {
	id
	name
	parent_id
	type
	stations {
			${Object.keys(new UpdateStationInput()).join('\n')}
			icon
	}
	areas {
	${Object.keys(new UpdateAreaInput()).join('\n')}
	}
	parentEntrances {
			id
	}
	subEntrances {
			id
	}
}
`

export const RequestUpcomingSubSubEventsParameters = `
id
parent_id
name
description
image
attachments
keep_open
opening_time
starting_time
closing_time
parent_name
predefined_location_id
sub_event_area_ids
`

export const RequestPreviewFieldsAuthorizedPage = `
id
name
allow_transfer
client_id
location {
	id
	name
	display_name
	description
	address
}
${areasStatisticsForAuthorized}
event_statistics{
	icon
}
entrances {
	id
	name
	type
	areas {
		${Object.keys(new UpdateAreaInput()).join('\n')}
	}
}
keep_open
starting_time
closing_time
time_limitations
`

export const RequestPreviewBranchFieldPassModal = `
  id
  name
  client_id
  allow_transfer
  location {        
    id
    name
  }
  entrances {
    id
    name
    parent_id
    type
    stations {
        ${Object.keys(new UpdateStationInput()).join('\n')}
        icon
    }
   areas {
    ${Object.keys(new UpdateAreaInput()).join('\n')}
   }
    parentEntrances {
        id
    }
    subEntrances {
        id
    }
}
event_statistics{
    icon
}
keep_open
starting_time
closing_time
time_limitations
image
  `

export const BRANCH_AREAS_QUERY = `
  id
	name
	image
	opening_time
	closing_time
  areas {
    ${Object.keys(new UpdateAreaInput()).join('\n')}
	}
  `
